import { render, staticRenderFns } from "./TakeawayOrder.vue?vue&type=template&id=038c1bad"
import script from "./TakeawayOrder.vue?vue&type=script&lang=js"
export * from "./TakeawayOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports